import React, { useCallback } from 'react';
import { List, Seq } from 'immutable';

import InfiniteScroll from 'react-infinite-scroll-component';
import TicketListItem from 'flow/components/tickets/tickets-list/list-item/TicketListItem';
import { TicketKey } from 'flow/types/EntityKeys';
import TicketsListSkeleton, {
    TicketsListItemSkeleton,
} from './list-item/TicketsListSkeleton';

interface Props {
    displayLoadingItem: boolean;
    canFetchMoreData: boolean;
    scrollableTargetId: string;
    itemKeys: Seq.Indexed<TicketKey> | List<TicketKey>;
    itemSelectedKey?: TicketKey;
    handleListItemClicked: (key: TicketKey) => void;
    onReachedEndOfList: () => void;
}

const TicketsList = ({
    itemKeys,
    itemSelectedKey,
    displayLoadingItem,
    onReachedEndOfList,
    canFetchMoreData,
    scrollableTargetId,
    handleListItemClicked,
}: Props) => {
    const onClickListItem = useCallback(
        (ticketKey: TicketKey) => {
            handleListItemClicked(ticketKey);
        },
        [handleListItemClicked],
    );

    if (displayLoadingItem) {
        return <TicketsListSkeleton />;
    }

    return (
        <InfiniteScroll
            className="antialiased"
            dataLength={itemKeys.size}
            next={onReachedEndOfList}
            hasMore={canFetchMoreData}
            loader={<TicketsListItemSkeleton />}
            scrollableTarget={scrollableTargetId}
        >
            {itemKeys
                .map((key) => (
                    <TicketListItem
                        key={key}
                        ticketKey={key}
                        onClick={onClickListItem}
                        isSelected={itemSelectedKey === key}
                    />
                ))
                .toArray()}
        </InfiniteScroll>
    );
};

export default React.memo(TicketsList);
